import { render } from "./ajax-modal.vue?vue&type=template&id=4655b980"
import script from "./ajax-modal.vue?vue&type=script&lang=js"
export * from "./ajax-modal.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/ajax-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4655b980"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4655b980', __exports__)) {
    console.log('reload')
    api.reload('4655b980', __exports__)
  }
  
  module.hot.accept("./ajax-modal.vue?vue&type=template&id=4655b980", () => {
    console.log('re-render')
    api.rerender('4655b980', render)
  })

}


export default __exports__